import { motion } from "motion/react";

export function AnimatedBackground() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden">
      {/* Animated gradient background */}
      <motion.div
        className="absolute inset-0"
        animate={{
          background: [
            "linear-gradient(135deg, #667eea 0%, #764ba2 25%, #f093fb 50%, #4facfe 75%, #667eea 100%)",
            "linear-gradient(135deg, #f093fb 0%, #667eea 25%, #764ba2 50%, #4facfe 75%, #f093fb 100%)",
            "linear-gradient(135deg, #4facfe 0%, #f093fb 25%, #667eea 50%, #764ba2 75%, #4facfe 100%)",
            "linear-gradient(135deg, #764ba2 0%, #4facfe 25%, #f093fb 50%, #667eea 75%, #764ba2 100%)",
            "linear-gradient(135deg, #667eea 0%, #764ba2 25%, #f093fb 50%, #4facfe 75%, #667eea 100%)"
          ]
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: "linear"
        }}
        style={{
          backgroundSize: "400% 400%"
        }}
      />

      {/* Animated orbs */}
      <motion.div
        className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full opacity-30 blur-3xl"
        animate={{
          x: [0, 100, 0, -100, 0],
          y: [0, -100, 0, 100, 0],
          scale: [1, 1.2, 1, 0.8, 1],
          background: [
            "radial-gradient(circle, rgba(255,255,255,0.3) 0%, rgba(147,51,234,0.2) 100%)",
            "radial-gradient(circle, rgba(147,51,234,0.3) 0%, rgba(59,130,246,0.2) 100%)",
            "radial-gradient(circle, rgba(59,130,246,0.3) 0%, rgba(236,72,153,0.2) 100%)",
            "radial-gradient(circle, rgba(236,72,153,0.3) 0%, rgba(255,255,255,0.2) 100%)",
            "radial-gradient(circle, rgba(255,255,255,0.3) 0%, rgba(147,51,234,0.2) 100%)"
          ]
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />

      <motion.div
        className="absolute bottom-1/4 right-1/4 w-96 h-96 rounded-full opacity-30 blur-3xl"
        animate={{
          x: [0, -100, 0, 100, 0],
          y: [0, 100, 0, -100, 0],
          scale: [1, 0.8, 1, 1.2, 1],
          background: [
            "radial-gradient(circle, rgba(59,130,246,0.3) 0%, rgba(147,51,234,0.2) 100%)",
            "radial-gradient(circle, rgba(236,72,153,0.3) 0%, rgba(59,130,246,0.2) 100%)",
            "radial-gradient(circle, rgba(255,255,255,0.3) 0%, rgba(236,72,153,0.2) 100%)",
            "radial-gradient(circle, rgba(147,51,234,0.3) 0%, rgba(255,255,255,0.2) 100%)",
            "radial-gradient(circle, rgba(59,130,246,0.3) 0%, rgba(147,51,234,0.2) 100%)"
          ]
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 2
        }}
      />

      <motion.div
        className="absolute top-1/2 left-1/2 w-96 h-96 rounded-full opacity-30 blur-3xl"
        animate={{
          x: [0, 50, 0, -50, 0],
          y: [0, -50, 0, 50, 0],
          scale: [1, 1.1, 1, 0.9, 1],
          background: [
            "radial-gradient(circle, rgba(236,72,153,0.3) 0%, rgba(255,255,255,0.2) 100%)",
            "radial-gradient(circle, rgba(147,51,234,0.3) 0%, rgba(236,72,153,0.2) 100%)",
            "radial-gradient(circle, rgba(59,130,246,0.3) 0%, rgba(147,51,234,0.2) 100%)",
            "radial-gradient(circle, rgba(255,255,255,0.3) 0%, rgba(59,130,246,0.2) 100%)",
            "radial-gradient(circle, rgba(236,72,153,0.3) 0%, rgba(255,255,255,0.2) 100%)"
          ]
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 4
        }}
      />
    </div>
  );
}
